import { Circle as CoreCircle } from '@tink/core/src/components/atoms/Circle/Circle';
import { styled } from '../../../../../../../../core/theme/styled';

export const Circle = styled(CoreCircle)`
  margin-bottom: ${(props) => props.theme.sizes.xsmall};
  background-color: ${(props) => `${props.theme.palette.primary.main}19`}; /* 0.1 alpha */
`;
